import { ModalBody, type StackProps } from '@chakra-ui/react';

export type UiModalBodyProps = StackProps;

export const UiModalBody = ModalBody;
